module.exports = __webpack_public_path__ + "img/healthcare_icon_3.34889026.png";